// Considered states (DESIGN_SPEC §10.15). No toasts: feedback stays at the trigger; errors are inline and ink, never red.
//   <Empty inline? rule? figure? action? className?>No analyses yet.</Empty>
//       page: centered "·  ·  ·  ·  ·" rule + one Inter Tight line + one action (figure: e.g. a 72-col moth plate); inline: one prose line in a figure
//   <Loading verb? className?>for the guest agent · VM booting since 06:44:10</Loading>   faint mono, shows after 250 ms; verb breathes
//   <Alert head actions? ref? className?>502 from /v1/jobs/…/events · retrying in 4 s</Alert>   "× HEAD" + status/path + a way out; focusable (tabIndex -1)
//   <LiveLine state? batchId? className?><b>Live</b> · 0.6 ev/s · last event 0.8 s ago</LiveLine>
//       state: live (pip rings once per batchId) | idle (faint, still) | lost (hollow) | ended (no pip)
import type { ReactNode, Ref } from "react";
import { Pip } from "./Glyphs";
import { cx } from "./cx";

export function Empty({
  inline,
  rule = true,
  figure,
  action,
  className,
  children,
}: {
  inline?: boolean;
  rule?: boolean;
  figure?: ReactNode;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={cx("empty", inline && "empty--inline", className)}>
      {figure}
      {rule && (
        <span className="empty-rule" aria-hidden="true">
          · · · · ·
        </span>
      )}
      <p>{children}</p>
      {action}
    </div>
  );
}

export function Loading({ verb, className, children }: { verb?: ReactNode; className?: string; children?: ReactNode }) {
  return (
    <p className={cx("loading", className)} role="status">
      {verb && <span className="breathe">{verb}</span>}
      {verb && children ? " " : null}
      {children}
    </p>
  );
}

export function Alert({
  head,
  actions,
  className,
  ref,
  children,
}: {
  head: ReactNode;
  actions?: ReactNode;
  className?: string;
  ref?: Ref<HTMLDivElement>;
  children?: ReactNode;
}) {
  return (
    <div ref={ref} className={cx("alert", className)} role="alert" tabIndex={-1}>
      <b>× {head}</b>
      {children && <span>{children}</span>}
      {actions && <span className="acts">{actions}</span>}
    </div>
  );
}

export function LiveLine({
  state = "live",
  batchId,
  className,
  children,
}: {
  state?: "live" | "idle" | "lost" | "ended";
  batchId?: string | number;
  className?: string;
  children: ReactNode;
}) {
  // The pip flows inline with the text, so a wrapped line on a phone keeps its pip on the first line.
  return (
    <p className={cx("liveline", className)}>
      <span className="min-w-0">
        {state !== "ended" && <Pip state={state} batchId={batchId} className="mr-2.5" />}
        {children}
      </span>
    </p>
  );
}
